<template>
  
  <input
    :id="name"
    :type="type"
    :name="name"
    v-model.lazy="value"
    @focus="onFocusFormControlEl"
    @blur="onBlurFormControlEl"
  >

</template>

<script>
  export default {
    name: 'FormControlText',

    props: {
      name: {
        type: String,
        required: true,
      },

      type: {
        type: String,
        default: 'text',
      },
    },

    data() {
      return {
        focused: false,
        value: null,
      };
    },

    computed: {
      filled() {
        return (this.value !== null)
          && (this.value !== '')
          && (this.value !== undefined);
      },
    },

    watch: {
      value(value) {
        this.$emit('value', value);
      },

      filled(value) {
        this.$emit('filled', value);
      },

      focused(value) {
        this.$emit('focused', value);
      },
    },

    methods: {
      onFocusFormControlEl() {
        this.focused = true;
      },

      onBlurFormControlEl() {
        this.focused = false;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/FormControlText.vue